import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {DepotService} from "../services/depot-service/depot.service";
import {Depot} from "../../shared/view-model/store-management/depot.type";
import {ApolloQueryObservable} from "apollo-angular";
import {
  AdministrationUnitService,
  FetchSubAdminUnitsResult
} from "../../organization/services/administration_unit_service/administration-unit.service";
import {AdministrationUnit} from "../../shared/view-model/organization/administration-unit.type";
import {SessionActions} from "../../shared/actions/session.actions";
import {AbstractVisbosComponent} from "../../core/visbos-core/components/abstract-visbos.component";
import {AdminUnitActions} from "../../shared/actions/admin-unit.actions";
import {Stock} from "../../shared/view-model/stock";
import {StockService} from "../services/stock.service";

@Component({
  selector: 'vb-store-dashboard',
  templateUrl: './store-dashboard.component.html',
  styleUrls: ['./store-dashboard.component.css']
})
export class StoreDashboardComponent extends AbstractVisbosComponent implements OnInit {

  depots$: ApolloQueryObservable<Depot[]>;

  private subAdminUnits$: ApolloQueryObservable<FetchSubAdminUnitsResult>;
  subAdminUnits: AdministrationUnit[];

  private expiringStocks$: ApolloQueryObservable<any>;
  public expiringStocks: Stock[];


  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private adminUnitActions: AdminUnitActions,
              private route: ActivatedRoute,
              private router: Router,
              private depotService: DepotService,
              private adminUnitService: AdministrationUnitService,
              private stockService: StockService) {
    super(sessionActions, cd);
  }

  ngOnInit() {

    super.ngOnInit();

    this.depots$ = this.depotService.getDepotsWithStocks(true, this.activeAdminUnitCuid$);
    this.addComponentData(this.depots$);

    this.subAdminUnits$ = this.adminUnitService.getSubAdminUnitsWithStocks(null, true);
    this.addComponentData(this.subAdminUnits$);
    this.dataSubscriptions.push(this.subAdminUnits$.subscribe(res => {
      this.subAdminUnits = res.data.subAdminUnits;
    }));

    this.expiringStocks$ = this.stockService.fetchExpiringStocks();
    this.addComponentData(this.expiringStocks$);
    this.addSubscription(this.expiringStocks$.subscribe(res => {
      this.expiringStocks = res.data.expiringStocks;
    }));

  }

  showStockDetail(stockId) {
    let link = ['bestand', stockId];
    this.router.navigate(link, {relativeTo: this.route});
  }

  gotoStockForDepot(depot: Depot) {
    let link = ['lager', depot.cuid, 'bestand'];
    this.router.navigate(link, {relativeTo: this.route});
  }

  gotoStockForSubAdminUnit(adminUnit: AdministrationUnit) {
    this.adminUnitActions.selectAdminUnit(adminUnit.cuid);
    let link = ['lager', 'bestand'];
    this.router.navigate(link, {relativeTo: this.route});
  }

  gotoWithdrawals() {
    let link = ['entnahmeprotokoll'];
    this.router.navigate(link, {relativeTo: this.route});
  }

  gotoDispatchForDepot(depotCuid) {
    let link = ['lager', depotCuid, 'bestand', 'bedarf'];
    this.router.navigate(link, {relativeTo: this.route});
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/store-dashboard/store-dashboard.component.ts